import { useContext } from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay/legacy';

import { ServerVarsContext } from '../../global/ServerVarsContext/ServerVarsContext';
import { SbRespContentModuleRegular } from '../../finding/SbRespContentModuleRegular/SbRespContentModuleRegular';
import { SbMobileContentModuleRegular } from '../../finding/SbMobileContentModuleRegular/SbMobileContentModuleRegular';

import styles from './buySharedContentModularRegular.scss';

export const BuySharedContentModuleRegularComponent = ({ browseContentModule }) => {
    const { isMobile } = useContext(ServerVarsContext);
    if (browseContentModule && browseContentModule.description) {
        return (
            <div className={styles.wrapper}>
                {isMobile ? (
                    <SbMobileContentModuleRegular browseContentModule={browseContentModule} />
                ) : (
                    <SbRespContentModuleRegular browseContentModule={browseContentModule} />
                )}
            </div>
        );
    }
    return null;
};

BuySharedContentModuleRegularComponent.propTypes = {
    browseContentModule: PropTypes.object,
};

export const BuySharedContentModuleRegular = createFragmentContainer(
    BuySharedContentModuleRegularComponent,
    {
        browseContentModule: graphql`
            fragment BuySharedContentModuleRegular_browseContentModule on ContentModuleRegular {
                description
                ...SbMobileContentModuleRegular_browseContentModule
                ...SbRespContentModuleRegular_browseContentModule
            }
        `,
    }
);
